import { createJSONStorage } from 'zustand/middleware';

var t=()=>localStorage;function S(e){t=()=>e;}function g(){return createJSONStorage(t)}

export { S as a, g as b };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-EHGWCVTQ.mjs.map